import React from "react";
import { Tabs } from "@ann/web-components";
import { TabsContainer } from "./Tabs.styled";
import { DepartmentDetailsTabsEnum } from "../../enums/departmentDetailsTabs";

const DepartmentDetailsTabs = ({ onTabChange, defaultIndex = DepartmentDetailsTabsEnum.OVERVIEW }) => {
  const handleTabChange = (index) => {
    if (onTabChange) {
      onTabChange(index);
    }
  };

  return (
    <TabsContainer>
      <Tabs defaultIndex={defaultIndex} size="medium" onChange={handleTabChange}>
        <Tabs.List>
          <Tabs.Tab iconLeft="short_text" index={DepartmentDetailsTabsEnum.OVERVIEW}>
            Overview
          </Tabs.Tab>
          <Tabs.Tab iconLeft="person" index={DepartmentDetailsTabsEnum.USERS}>
            Users
          </Tabs.Tab>
          <Tabs.Tab iconLeft="data_table" index={DepartmentDetailsTabsEnum.KNOWLEDGE_BASES}>
            Knowledge Bases
          </Tabs.Tab>
          <Tabs.Tab iconLeft="list" index={DepartmentDetailsTabsEnum.ACTIVITY_LOG}>
            Audit Log
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
    </TabsContainer>
  );
};

export default DepartmentDetailsTabs;

